import { FC } from 'react';

import { RichTextContent } from '@telialt/common-rich-text-content/src/RichTextContent';

import { BlogSectionType } from '../../../models/Content';
import { QuoteAuthor, QuoteContent, QuoteIcon, StyledSectionQuote } from './SectionQuote.styles';
import { transformSectionQuote } from './transformers';

type Props = {
    contentItem: BlogSectionType;
};

export const SectionQuote: FC<Props> = ({ contentItem }) => {
    const { quote, author } = transformSectionQuote(contentItem);

    return (
        <StyledSectionQuote>
            <QuoteIcon>
                <svg width="47" height="37" viewBox="0 0 47 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M10.9243 36.3297C7.96036 36.3297 5.37748 35.1441 3.17568 32.773C1.05856 30.3171 0 27.1838 0 23.373C0 19.4775 0.804505 15.836 2.41351 12.4487C4.10721 9.06127 6.47838 6.26667 9.52703 4.06487C12.5757 1.77838 16.0901 0.423428 20.0703 0V7.4946C18.1225 7.66397 16.1748 8.51082 14.227 10.0351C12.364 11.5595 10.9667 13.5072 10.0351 15.8784C13.4225 15.8784 16.0901 16.9793 18.0378 19.1811C20.0703 21.2982 21.0865 23.627 21.0865 26.1676C21.0865 28.7928 20.0703 31.164 18.0378 33.2811C16.0054 35.3135 13.6342 36.3297 10.9243 36.3297ZM25.9135 23.373C25.9135 19.4775 26.718 15.836 28.327 12.4487C30.0207 9.06127 32.3919 6.26667 35.4405 4.06487C38.4892 1.77838 42.0036 0.423428 45.9838 0V7.4946C44.036 7.66397 42.0883 8.51082 40.1405 10.0351C38.2775 11.5595 36.8802 13.5072 35.9487 15.8784C39.336 15.8784 42.0036 16.9793 43.9514 19.1811C45.9838 21.2982 47 23.627 47 26.1676C47 28.7928 45.9838 31.164 43.9514 33.2811C41.9189 35.3135 39.5477 36.3297 36.8378 36.3297C33.8739 36.3297 31.291 35.1441 29.0892 32.773C26.9721 30.3171 25.9135 27.1838 25.9135 23.373Z"
                        fill="currentColor"
                    />
                </svg>
            </QuoteIcon>
            <QuoteContent>
                <RichTextContent richText={quote} />
                <QuoteAuthor>{author}</QuoteAuthor>
            </QuoteContent>
        </StyledSectionQuote>
    );
};
